import { React, useCallback, useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Modal, Upload } from 'antd'
import { isEmpty, noop, stubFalse } from 'lodash'
import PropTypes from 'prop-types'

import { convertFileListToDataUrls } from '../../utils'

const ImageUpload = ({ onUpload, onRemove, disabled, fileList, onChange }) => {
  const [isPreviewingImage, setIsPreviewingImage] = useState(false)
  const [localFileList, setLocalFileList] = useState(fileList)
  const [imageDataUrl, setImageDataUrl] = useState()

  const closePreview = useCallback(() => {
    setIsPreviewingImage(false)
  }, [])

  const openPreview = useCallback(() => {
    setIsPreviewingImage(true)
  }, [setIsPreviewingImage])

  useEffect(() => {
    const initializeImageDataUrl = async () => {
      const imageDataUrls = await convertFileListToDataUrls(fileList)
      setImageDataUrl(imageDataUrls[0])
      if (isEmpty(imageDataUrls)) {
        setLocalFileList([])
      } else {
        setLocalFileList(prevFileList => [
          {
            ...prevFileList[0],
            url: imageDataUrls[0],
            thumbUrl: imageDataUrls[0],
          },
        ])
      }
    }

    initializeImageDataUrl()
  }, [fileList])

  return (
    <div>
      <Modal
        visible={isPreviewingImage}
        footer={null}
        onCancel={closePreview}
        width="auto"
      >
        <img alt="preview" src={imageDataUrl} />
      </Modal>
      <Upload
        disabled={disabled}
        accept="image/*"
        listType="picture-card"
        fileList={localFileList}
        onPreview={openPreview}
        onChange={onChange}
        beforeUpload={onUpload}
        onRemove={onRemove}
      >
        {isEmpty(localFileList) && (
          <div>
            <PlusOutlined />
            <div className="ant-upload-text">Upload</div>
          </div>
        )}
      </Upload>
    </div>
  )
}

ImageUpload.propTypes = {
  fileList: PropTypes.array,
  onChange: PropTypes.func,
  onUpload: PropTypes.func,
  onRemove: PropTypes.func,
  disabled: PropTypes.bool,
}

ImageUpload.defaultProps = {
  fileList: [],
  onUpload: stubFalse,
  onRemove: noop,
  onChange: undefined,
  disabled: false,
}

export default ImageUpload
